export { default } from './components/ModalConfirm';
